export enum RecordType {
	Check = 'C',
	Eft = 'E',
	Deposit = 'D',
	Adjustment = 'A',
	BankEntry = 'B',
}
